'use client';

import { Button, type ButtonProps } from '@andritzot/metris-web-ui/inputs/button';
import { CircularProgress } from '@andritzot/metris-web-ui/feedback/progress/circular-progress';
import { type ReactNode } from 'react';

interface LoadingButtonProps extends Omit<ButtonProps, 'startIcon'> {
  loading: boolean;
  icon: ReactNode;
}

export function LoadingButton({ loading, icon, disabled, children, ...props }: Readonly<LoadingButtonProps>) {
  return (
    <Button
      {...props}
      startIcon={loading ? <CircularProgress size={16} /> : icon}
      disabled={loading || disabled}
    >
      {children}
    </Button>
  );
}
